import { initialState } from "us.collection.economy/reducers/RemitDetails/State";
import { RemitDetails } from "us.collection.economy/constants/Actions";

const {
  GET_REMIT_DETAILS,
  GET_REMIT_DETAILS_SUCCESS,
  GET_REMIT_DETAILS_FAIL,
} = RemitDetails;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_REMIT_DETAILS:
      return Object.assign({}, state, {
        remittedDetails: initialState.remittedDetails,
        isDetailsLoading: true,
      });
    case GET_REMIT_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        remittedDetails: {data :payload?.data, isLoading: false},
        isDetailsLoading: false,
      });
    case GET_REMIT_DETAILS_FAIL:
      return Object.assign({}, state, {
        remittedDetails: {...initialState.remittedDetails, isLoading:false},
        isDetailsLoading: false,
      });
    default:
      return state;
  }
};
